(function () {
  function setupWaitlistDialog(container) {
    var trigger = container.querySelector("[data-waitlist-open]");
    var dialog = container.querySelector("[data-waitlist-dialog]");
    if (!trigger || !dialog || dialog.dataset.initialized === "true") return;

    var closeButton = dialog.querySelector("[data-waitlist-close]");

    function setPageLocked(locked) {
      document.documentElement.classList.toggle("avyu-modal-open", locked);
      document.body.classList.toggle("avyu-modal-open", locked);
    }

    function openDialog(event) {
      if (event) event.preventDefault();

      if (typeof dialog.showModal === "function") {
        if (!dialog.open) dialog.showModal();
      } else {
        dialog.setAttribute("open", "");
      }

      setPageLocked(true);
      window.setTimeout(function () {
        if (closeButton) closeButton.focus();
      }, 0);
    }

    function closeDialog() {
      if (typeof dialog.close === "function" && dialog.open) {
        dialog.close();
      } else {
        dialog.removeAttribute("open");
        setPageLocked(false);
        trigger.focus();
      }
    }

    trigger.addEventListener("click", openDialog);
    if (closeButton) closeButton.addEventListener("click", closeDialog);

    dialog.addEventListener("click", function (event) {
      if (event.target === dialog) closeDialog();
    });

    dialog.addEventListener("close", function () {
      setPageLocked(false);
      trigger.focus();
    });

    dialog.addEventListener("cancel", function () {
      setPageLocked(false);
    });

    document.addEventListener("keydown", function (event) {
      if (event.key === "Escape" && dialog.hasAttribute("open") && typeof dialog.close !== "function") {
        closeDialog();
      }
    });

    dialog.dataset.initialized = "true";
  }

  function showFinalState(container) {
    container.querySelectorAll(".avyu-art-image").forEach(function (image) {
      image.removeAttribute("mask");
    });

    container.dataset.ready = "true";
  }

  function startAvyuEvent() {
    var container = document.querySelector("[data-avyu-event]");
    if (!container) return;

    setupWaitlistDialog(container);

    if (!window.gsap) {
      showFinalState(container);
      return;
    }

    var gsap = window.gsap;
    var reduceMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    var paths = container.querySelectorAll(".avyu-motion-path");
    var maskCompletes = container.querySelectorAll(".avyu-mask-complete");
    var waveUnderlays = container.querySelectorAll(".avyu-wave-underlay");
    var treeCanopy = container.querySelector(".avyu-tree-canopy-reveal");
    var treeImage = container.querySelector(".avyu-ornament--tree .avyu-art-image");
    var quoteLines = container.querySelectorAll(".avyu-event__quote-line");
    var quoteLineOne = container.querySelector(".avyu-event__quote-line--one");
    var quoteLineTwo = container.querySelector(".avyu-event__quote-line--two");
    var artwork = container.querySelector(".avyu-event__artwork");

    paths.forEach(function (path) {
      var length = path.getTotalLength();
      gsap.set(path, {
        strokeDasharray: length + " " + length,
        strokeDashoffset: length + 2,
        opacity: 0,
      });
    });

    gsap.set(quoteLines, { clipPath: "inset(0 100% 0 0)" });
    gsap.set(maskCompletes, { attr: { opacity: 0 } });
    gsap.set(treeCanopy, { attr: { x: 1920, width: 0 } });
    gsap.set(container.querySelector(".waitlist-action"), { autoAlpha: 0, scale: 0.96, y: 10 });
    gsap.set(waveUnderlays, { autoAlpha: 0 });
    gsap.set(container.querySelector(".avyu-event__logo"), { autoAlpha: 0, y: -5 });
    gsap.set(container.querySelectorAll(".avyu-event__socials a"), { autoAlpha: 0, y: -5 });
    container.dataset.ready = "true";

    if (reduceMotion) {
      gsap.set(paths, { strokeDashoffset: 0, opacity: 1 });
      gsap.set(maskCompletes, { attr: { opacity: 1 } });
      gsap.set(treeCanopy, { attr: { x: 1300, width: 620 } });
      gsap.set(waveUnderlays, { autoAlpha: 0 });
      gsap.set(quoteLines, { clipPath: "inset(0 0% 0 0)" });
      gsap.set(container.querySelector(".waitlist-action"), { autoAlpha: 1, scale: 1, y: 0 });
      gsap.set(container.querySelector(".avyu-event__logo"), { autoAlpha: 1, y: 0 });
      gsap.set(container.querySelectorAll(".avyu-event__socials a"), { autoAlpha: 1, y: 0 });
      showFinalState(container);
      return;
    }

    var timeline = gsap.timeline({ defaults: { ease: "power1.inOut" } });
    var branches = artwork.querySelectorAll(".avyu-motion-path--branch");
    var waves = artwork.querySelectorAll(".avyu-motion-path--waves");
    var chairs = artwork.querySelectorAll(".avyu-motion-path--chair");
    var branchCompletion = artwork.querySelectorAll(".avyu-mask-complete--branch");
    var waveCompletion = artwork.querySelectorAll(".avyu-mask-complete--waves");
    var chairCompletion = artwork.querySelectorAll(".avyu-mask-complete--chair");

    timeline
      .to(container.querySelector(".avyu-event__logo"), { autoAlpha: 1, y: 0, duration: 0.55, ease: "power2.out" }, 0.25)
      .to(quoteLineOne, { clipPath: "inset(0 0% 0 0)", duration: 1.68, ease: "power1.inOut" }, 0)
      .to(quoteLineTwo, { clipPath: "inset(0 0% 0 0)", duration: 1.9, ease: "power1.inOut" }, 1.58)
      .set(branches, { opacity: 1 }, 1.45)
      .to(branches, { strokeDashoffset: 0, duration: 3.2, stagger: 0.12, ease: "sine.inOut" }, 1.45)
      .to(branchCompletion, { attr: { opacity: 1 }, duration: 1.15, ease: "sine.inOut" }, 4.45)
      .to(treeCanopy, { attr: { x: 1300, width: 620 }, duration: 4, ease: "sine.inOut" }, 1.5)
      .call(function () { treeImage.removeAttribute("mask"); }, null, 5.55)
      .set(waves, { opacity: 1 }, 1.85)
      .to(waves, { strokeDashoffset: 0, duration: 4.85, ease: "sine.inOut" }, 1.85)
      .to(waveUnderlays, { autoAlpha: 0.46, duration: 4.85, ease: "sine.inOut" }, 1.85)
      .to(waveCompletion, { attr: { opacity: 1 }, duration: 1.15, ease: "sine.inOut" }, 6.05)
      .to(waveUnderlays, { autoAlpha: 0, duration: 1.15, ease: "sine.inOut" }, 6.05)
      .to(container.querySelector(".waitlist-action"), { autoAlpha: 1, scale: 1, y: 0, duration: 0.9, ease: "power2.out" }, 3.75)
      .to(container.querySelectorAll(".avyu-event__socials a"), { autoAlpha: 1, y: 0, duration: 0.5, stagger: 0.1, ease: "power2.out" }, 4.35)
      .set(chairs, { opacity: 1 }, 4.5)
      .to(chairs, { strokeDashoffset: 0, duration: 1.8, stagger: 0.1, ease: "sine.inOut" }, 4.5)
      .to(chairCompletion, { attr: { opacity: 1 }, duration: 1.15, ease: "sine.inOut" }, 6.05);
  }

  function startWhenReady() {
    var fontReady = document.fonts
      ? document.fonts.load('400 1em "AVYU Shobhika"')
      : Promise.resolve();
    var timeout = new Promise(function (resolve) {
      window.setTimeout(resolve, 1800);
    });

    Promise.race([fontReady, timeout]).then(startAvyuEvent, startAvyuEvent);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", startWhenReady, { once: true });
  } else {
    startWhenReady();
  }
})();
